module.exports = __webpack_public_path__ + "img/ic-gemestone-black.2c1edaea.svg";